import { Component, OnInit, ViewChild } from '@angular/core';
import { MatTableDataSource, MatPaginator, MatSort,DateAdapter, MAT_DATE_LOCALE, MAT_DATE_FORMATS } from '@angular/material';
import { FormControl, FormGroup } from '@angular/forms';
import { DatePipe } from "@angular/common";
import Swal from "sweetalert2";
import { MomentDateAdapter } from "@angular/material-moment-adapter";
import { MessagesTitles, MessagesGeneral, MessagesDates } from '../../../models/messages';
import * as moment from 'moment';
import { LiquidacionService } from 'app/services/liquidacion/liquidacion.service';
import { FiltrosLiquidaciones } from 'app/models/FiltrosLiquidaciones';
import { environment } from 'environments/environment';


export const MY_FORMATS = {
    parse: {
      dateInput: "DD-MM-YYYY"
    },
    display: {
      dateInput: "DD-MM-YYYY",
      monthYearLabel: "MMM YYYY",
      dateA11yLabel: "LL",
      monthYearA11yLabel: "MMMM YYYY"
    }
  };
  declare var $: any;
  @Component({
    selector: 'app-nuevo-planillaLiquidacion',
    templateUrl: './nuevo-planillaLiquidacion.component.html',
    styleUrls: ['./nuevo-planillaLiquidacion.component.scss'],
    providers: [MessagesTitles,MessagesGeneral,MessagesDates,
      DatePipe,
    
      {
        provide: DateAdapter,
        useClass: MomentDateAdapter,
        deps: [MAT_DATE_LOCALE]
      },
  
      { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS }]
})

export class NuevoPlanillaLiquidacionComponent implements OnInit{

  Label_Proveedor=environment.LABEL_PROVEEDOR;
  Label_Proveedores=environment.LABEL_PROVEEDORES;
  Label_Adquirente=environment.LABEL_ADQUIRENTE;
  Label_Adquirentes=environment.LABEL_ADQUIRENTES;
  Label_id_soles=environment.ID_GUIA_SOLES;
  Label_id_dolares=environment.ID_GUIA_DOLARES;
    DTOFiltrosLiquidaciones: FiltrosLiquidaciones = new FiltrosLiquidaciones();
    liquidaciones : any = [];
    check0: boolean = false;
    value = '';
    idLiquidacion : number = 0;
    tipoMoneda:string = "1";
    desembolsoGeneral: any = [];
    flag:boolean = false;

    filterForm =  new FormGroup({
      provFilter: new FormControl(''),
      adqFilter: new FormControl(''),
      idProvFilter: new FormControl(''),
      idAdqFilter: new FormControl(''),
      monedaFilter: new FormControl({value: 0,disabled: false}),
      estadoFilter: new FormControl({value: "",disabled: false}),
      fromDate: new FormControl({value: '',disabled: true}),
      toDate: new FormControl({value: '',disabled: true})
    });
    
    @ViewChild(MatPaginator, {static: true}) paginator: MatPaginator;  
    @ViewChild(MatSort, {static: true}) sort: MatSort;

    pageSizeOptions = [10,20,30,50,100,200];
    loading:boolean=false;

    displayedColumns: string[] =['checked','idLiquidacion','Fecha','pNomComercial','Mon','Interes_Prov','Interes_Adq','Desembolso'];

    dataSource :any;
    constructor(private datepipe:DatePipe, private liquidacionService:LiquidacionService){       
    }
    
    applyFilter(filterValue: string) {
      if(null != this.dataSource){
         this.dataSource.filter = filterValue.trim().toLowerCase();
      }
    }

    ngOnInit(){
      this.obtenerListaResumenLiquidacion();
    }

    obtenerListaResumenLiquidacion(){
        
      this.loading = true;
      this.limpiar();
      let desde: string = this.datepipe.transform(moment().add(-30, 'day'),'yyyy-MM-dd');
      let hasta: string = this.datepipe.transform(moment(),'yyyy-MM-dd');
  
      this.filterForm.get('fromDate').setValue(desde);
      this.filterForm.get('toDate').setValue(hasta);
  
      this.liquidacionService.obtenerResumenLiquidaciones(this.filterForm.getRawValue()).subscribe(
        res =>{
            this.liquidaciones = res;
            if(this.tipoMoneda === "0"){
              this.liquidaciones = this.liquidaciones.filter(object => object.Moneda == this.Label_id_soles); 
            } else {
              this.liquidaciones = this.liquidaciones.filter(object => object.Moneda == this.Label_id_dolares); 
            }
            this.liquidaciones = this.liquidaciones.filter(object => object.Estado == "C"); 
            this.dataSource = new MatTableDataSource(this.liquidaciones);
            this.dataSource.sort = this.sort;
            this.dataSource.paginator = this.paginator;
            this.loading = false;
        },err =>{
            Swal.fire({
                title: "¡Algo salió mal!",
                text:  err.error['error'],
                type: "warning",
                allowOutsideClick: true,
                heightAuto: false 
            });
            this.loading = false;
        }
      )
    }

    Agregar(element: any){
      if(element.checked){
        this.desembolsoGeneral.push(element);
      }else{                    
         this.desembolsoGeneral = this.desembolsoGeneral.filter(function(dato){
           if (dato.idResumen_Liquidaciones == element['idResumen_Liquidaciones']) {
             return false;
           } else {
             return true;
           }
         })
        
      }
      
    }

    openForm(){
      if(this.desembolsoGeneral.length == 0){
        Swal.fire({
          title: 'Atención!',
          text: 'No se han selecionado registros.',
          type: 'info',
          heightAuto: false
        })
      } else {
        this.flag = true;
      }
    }

    CerrarVentana(){
      this.flag = false;
    }

    limpiar(){
      if(this.desembolsoGeneral.length == 0){
        this.desembolsoGeneral = this.liquidaciones;
        this.liquidaciones.map(object => object.checked = true);
      } else {
        this.desembolsoGeneral = [];
        this.liquidaciones.map(object => object.checked = false);
      }
    }

    showNotification(type,from,align,message){
    
      $.notify({
          icon: "notifications",
          message: message
      },{
          type: type,
          timer: 4000,
          placement: {
              from: from,
              align: align
          },
          template: '<div data-notify="container" class="col-xl-4 col-lg-4 col-11 col-sm-4 col-md-4 alert alert-{0} alert-with-icon" role="alert">' +
            '<button mat-button  type="button" aria-hidden="true" class="close mat-button" data-notify="dismiss">  <i class="material-icons">close</i></button>' +
            '<i class="material-icons" data-notify="icon">notifications</i> ' +
            '<span data-notify="title">{1}</span> ' +
            '<span data-notify="message">{2}</span>' +
            '<div class="progress" data-notify="progressbar">' +
              '<div class="progress-bar progress-bar-{0}" role="progressbar" aria-valuenow="0" aria-valuemin="0" aria-valuemax="100" style="width: 0%;"></div>' +
            '</div>' +
            '<a href="{3}" target="{4}" data-notify="url"></a>' +
          '</div>'
      });
    }
}